import { Component } from '@angular/core';

@Component({
    selector: 'unlock-feature',
    templateUrl: './unlock-feature.component.html',
    styleUrls: ['./unlock-feature.component.scss'],
    standalone: false
})
export class UnlockFeatureComponent {}
